import i18n from "core/i18n";
import { FundSellScope } from "enums";

export const getLocalizedFundSellScope = i18n.createGetLocalizedEnumOptions(FundSellScope);
